export default "__VITE_ASSET__DZNRp0Sr__"